import { Component, OnInit } from '@angular/core';

import { QuestionnaireService } from '@shared/services/questionnaire.service';

import { LinkRendererComponent } from '@shared/components/cell-renderers/link-renderer/link-renderer.component';
import { Client } from '@app/shared/models/client';
@Component({
  selector: 'db-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  headerTitle = 'Clients';

  dataGridConfig;
  rowData: any;

  constructor(
    private questionnaireService: QuestionnaireService
  ) { }

  ngOnInit() {
    this.initializeRowData();
    this.configureGrid();
  }

  configureGrid() {
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Client Id',
          field: 'id',
          minWidth: 200
        },
        {
          headerName: 'Client Name',
          field: 'clientName',
          minWidth: 200
        },
        {
          headerName: 'Can',
          field: 'can',
          minWidth: 200
        },
        {
          headerName: 'Modified',
          field: 'date',
          minWidth: 150
        },
        {
          headerName: '',
          field: 'id',
          cellRenderer: 'linkRenderer',
          cellRendererParams: {
            inRouterLink: '/clients',
            linkTitle: 'View Client'
          },
          minWidth: 150,
          suppressSorting: true,
          suppressFilter: true
        }
      ],
      frameworkComponents: {
        linkRenderer: LinkRendererComponent
      }
    };
  }

  initializeRowData() {
    this.questionnaireService.getRecentClients()
      .subscribe((data: Client[]) => {
        this.rowData = data;
      });
  }

}
